import React from 'react';
import { Box } from '@mui/material';
import { DEFAULT_ROLE_TAG } from './notificationStrings';
import { BORDER, INK, RADIUS } from './notificationTokens';

/**
 * Small "DEFAULT" pill shown next to the Account Owner (guaranteed recipient).
 * Built from a plain Box rather than MUI <Chip> so its height/padding stay tight
 * (Chip enforces a min-height that reads as chunky next to the role name).
 */
const DefaultTag = () => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      height: 13,
      px: '4px',
      borderRadius: RADIUS.pill,
      border: `1px solid ${BORDER.default}`,
      color: INK.secondary,
      fontSize: 7.5,
      fontWeight: 700,
      lineHeight: 1,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap',
    }}
  >
    {DEFAULT_ROLE_TAG}
  </Box>
);

export { DefaultTag };
